// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const metang: PokeData = {
  "id": 375,
  "name": "metang",
  "height": 12,
  "weight": 2025,
  "base_experience": 147,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "hyper-beam",
    "confusion",
    "psychic",
    "agility",
    "scary-face",
    "pursuit",
    "metal-claw",
    "meteor-mash",
    "iron-defense",
    "miracle-eye",
    "magnet-rise",
    "bullet-punch",
    "zen-headbutt",
    "flash-cannon",
    "hone-claws"
  ],
  "moves": [
    "tackle",
    "psychic",
    "scary-face",
    "pursuit",
    "metal-claw",
    "meteor-mash",
    "zen-headbutt",
    "synchronize",
    "reflect",
    "smart-strike",
    "behemoth-bash",
    "psy-pulse",
    "metal-sound"
  ],
  "evolution_chain": {
    "id": 192,
    "item": null,
    "species": [
      {
        "name": "beldum",
        "order": 404,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "metang",
        "order": 405,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 374,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "metagross",
        "order": 406,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 375,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 45,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 50,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
